import http from "../../plugins/axios";

export default {
  getCycleList(data) {
    return http.get({
      url: "/admin/contract/share/cycleList",
      data
    });
  },
  getCycleDetail(data) {
    return http.get({
      url: "/admin/contract/share/cycleInfo",
      data
    });
  },
  getTempData(data) {
    return http.get({
      url: "/admin/contract/share/tempDataList",
      data
    });
  },

  addTempData(data) {
    return http.post({
      url: "/admin/contract/share/addTemp",
      data
      //dataType:'form'
    });
  },
  removeTempData(data) {
    return http.post({
      url: "/admin/contract/share/deleteTemp",
      data,
      dataType: "form"
    });
  },
  getRealData(data) {
    return http.get({
      url: "/admin/contract/share/shareDataList",
      data
    });
  },

  updateTotalRealFee(data) {
    return http.post({
      url: "/admin/contract/share/updateRealShareFee",
      data,
      dataType: "form"
    });
  },
  updateStatus(data) {
    return http.post({
      url: "/admin/contract/share/updateStatus",
      data,
      dataType: "form"
    });
  }
};
